const jquery = $;

const handleSetOptionValuesPosition = () => {
  let position = 1;

  $('.parent-dictionary')
    .find('.item')
    .each(function () {
      const dataTab = $(this).attr('data-tab');

      $(`div[data-tab="${dataTab}"]`)
        .find('.item')
        .each(function () {
          const secondDataTabAttr = $(this).attr('data-tab');
          const secondDataTabCodes = secondDataTabAttr.split('/');

          const formTab = $(`div[data-tab="${secondDataTabCodes[1]}"]`)
          const inputPosition = formTab.find('input[name*="position"]')

          inputPosition.val(position++)
        })
    })
}

$.fn.extend({
  handleInitOptionValueSortableList() {
    handleSetOptionValuesPosition()

    const sortableLists = document.querySelectorAll('.option-value-sortable-list');

    sortableLists.forEach(sortableList => {
      Sortable.create(sortableList, {
        onEnd: handleSetOptionValuesPosition
      });
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleInitOptionValueSortableList();
});
